// extracted by mini-css-extract-plugin
module.exports = {"root":"PjXbTf","noScrollSnap":"S7BjDq"};